// import Nodo from './Nodo.js';

class Vorto{
    constructor (nodo, id, lingvo, vorto, priskribo, ordo, uzita = null)
    {
        this.nodo = nodo;
        this.id = id;
        this.lingvo = lingvo;
        this.vorto = vorto;
        this.priskribo = priskribo;
        this.ordo = ordo;
        this.uzita = uzita;
    }
}

export default Vorto;